export default function responseHandler(response) {
  return response.data?.data || response.data;
}
